import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { CreateStagedShipmentInput, CreateStagedShipmentResponse } from '../../core/api/lab.types';

/* Create new CryoBox */
export const createStagedShipmentThunk = createAsyncThunk(
  'shipment/createStagedShipment',
  async (values: CreateStagedShipmentInput, { rejectWithValue }: any) => {
    const response: CreateStagedShipmentResponse = await labApi.createStagedShipment(values);
    if (response.data?.createStagedShipment) {
      return response.data?.createStagedShipment;
    }
    return rejectWithValue(response.errors);
  },
);
